export default "__VITE_ASSET__CsRYb6s3__"